/**
 * @generated SignedSource<<e4176df4bf5018a685b75a2d34030f8e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type RepeatTypeEnum = "daily" | "monthly" | "weekly" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PromotionUpdateDialog_promotion$data = {
  readonly endAt: any;
  readonly id: string;
  readonly isRepeat: boolean;
  readonly priority: number;
  readonly query: string | null;
  readonly repeatType: RepeatTypeEnum | null;
  readonly repeatValue: string | null;
  readonly startAt: any;
  readonly title: string;
  readonly " $fragmentType": "PromotionUpdateDialog_promotion";
};
export type PromotionUpdateDialog_promotion$key = {
  readonly " $data"?: PromotionUpdateDialog_promotion$data;
  readonly " $fragmentSpreads": FragmentRefs<"PromotionUpdateDialog_promotion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PromotionUpdateDialog_promotion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priority",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isRepeat",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "repeatType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "repeatValue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "query",
      "storageKey": null
    }
  ],
  "type": "Promotion",
  "abstractKey": null
};

(node as any).hash = "51da4a657507fdebd7e04dc30a5470fd";

export default node;
